import { Steps as ASteps } from "antd"
import { useRouter } from "next/router"
import { getRoute } from "./helpers"
import PropTypes from "prop-types"

// We are disabling this rule because showing components in a single line is more readable
/* eslint-disable react/jsx-max-props-per-line */

Steps.propTypes = {
  currentStepKey: PropTypes.string,
  stepsToOmit: PropTypes.array
}

export function Steps ({ currentStepKey, stepsToOmit = [] }) {
  const router = useRouter()

  const steps = [
    { key: "general-information", component: <ASteps.Step key="general-information" title="Inf. General" status="wait" /> },
    { key: "technical-specs", component: <ASteps.Step key="technical-specs" title="Ficha T" status="wait" /> },
    { key: "request-f21", component: <ASteps.Step key="request-f21" title="Participantes" status="wait" /> },
    { key: "sustainability", component: <ASteps.Step key="sustainability" title="Sostenibilidad" status="wait" /> },
    { key: "budget", component: <ASteps.Step key="budget" title="Presupuesto" status="wait" /> },
    { key: "timetable", component: <ASteps.Step key="timetable" title="Cronograma" status="wait" /> },
    { key: "human-resources", component: <ASteps.Step key="human-resources" title="RH y Consultores" status="wait" /> },
    { key: "comments", component: <ASteps.Step key="comments" title="Comentarios" status="wait" /> }
  ]
  .filter(step => !stepsToOmit.includes(step.key))

  let currentStepNumber = 0
  steps.find((step, idx) => {
    if (step.key === currentStepKey) {
      currentStepNumber = idx
      return true
    }
    return false
  })

  const handleChange = stepNumber => {
    if (!router?.query?.id) {
      return
    }
    const stepKeyName = steps[stepNumber].key || 0
    router.push(getRoute(router, stepKeyName))
  }

  return (
    <ASteps current={currentStepNumber} onChange={handleChange}>
      {steps.map(step => step.component)}
    </ASteps>
  )
}
